export default "__VITE_ASSET__75512442__"